import type { TOC } from '@ember/component/template-only'
import { t } from 'ember-intl'
import { PhosphorIcon } from 'teacher-ui-client/components/phosphor-icon'
import { teacherEventClick } from 'teacher-ui-client/modifiers/teacher-event'

interface Signature {
  Element: HTMLDivElement
}

export const InsightSurveyButton: TOC<Signature> = <template>
  <div data-test-teacher-home-insight-survey-button class="relative inline-block" ...attributes>
    <span class="bg-juicy-orange-300 absolute -top-0.75 -right-0.75 z-2 size-2.25 rounded-full border-2 border-white" />
    <span class="animate-pulse-ring bg-juicy-orange-300 absolute -top-0.75 -right-0.75 z-1 size-2.25 rounded-full" />
    <button
      type="button"
      data-posthog-teacher-survey-button
      class="border-juicy-orange-300 hover:bg-juicy-orange-100 inline-flex cursor-pointer items-center gap-1.5 rounded-md border-[1.5px] px-3.5 py-1.5 text-sm leading-[1.4] font-medium transition-colors duration-140"
      {{teacherEventClick "insight_survey_opened" "teacher-ui"}}
    >
      <PhosphorIcon @icon="phosphor-chat-circle" class="text-[15px]" />
      {{t "teacherHome.insightSurveyButton.label"}}
    </button>
  </div>
</template>

export default InsightSurveyButton
